// src/components/shared/ReferBanner.js
// Compact single-line version of the Refer a Friend prompt, for pages
// where the full card (Profile, Support) would be too much. Shows for
// EVERYONE — the goal is spreading the word, so signing in shouldn't be
// a requirement to share. Signed-in users get their personal link
// (attributed via ?ref=<uid>); signed-out visitors still get a working
// share button, just without attribution — there's no uid to attach.
import React from 'react';
import { useAuth } from '../../lib/AuthContext';
import toast from 'react-hot-toast';

export const ReferBanner = () => {
  const { user } = useAuth();

  const shareReferral = async () => {
    const link = user
      ? `https://gatheryourcommunity.com/?ref=${user.uid}`
      : `https://gatheryourcommunity.com`;
    const shareText = `Join me on Gather — everything happening locally, in one place: ${link}`;
    if (navigator.share) {
      try { await navigator.share({ text: shareText }); } catch {}
    } else {
      await navigator.clipboard.writeText(link);
      toast.success('Link copied!');
    }
    if (!user) {
      toast('Sign in any time to get your own personal invite link', { icon: '💡', duration: 4000 });
    }
  };

  return (
    <button
      onClick={shareReferral}
      style={{
        width: 'calc(100% - 40px)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        background: 'var(--sage-pale)', color: 'var(--sage-dark)', border: 'none', borderRadius: 14,
        padding: '12px 14px', fontSize: 13, fontWeight: 700, fontFamily: 'Nunito, sans-serif',
        cursor: 'pointer', margin: '4px 20px 14px',
      }}
    >
      💌 Know someone who'd love this? Share Gather
    </button>
  );
};

export default ReferBanner;
